export default function Header() {
  return (
    <header style={{
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2a3f5f 50%, #4a7ba7 100%)',
      padding: '0.5rem 1.5rem',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
      zIndex: 100
    }}>
      <div className="header-content" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <img src="/vtick.svg" alt="Vectis" style={{
          height: '2em'
        }} />
        <div>
          <h1 style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            marginBottom: '0.125rem',
            lineHeight: 1.2,
            margin: 0
          }}>
            Vectis Waypoint Editor
          </h1>
          <p style={{
            fontSize: '0.75rem',
            opacity: 0.9,
            lineHeight: 1.2,
            margin: 0
          }}>
            Universal Robots Program File Editor & Visualizer
          </p>
        </div>
      </div>
    </header>
  );
}


